export const LEGACY_BASE_PATH = '/dashboard/organisation/services/legacy'
